/* ============================================================
   PRODUCT VAULT — Interactions
   Variant selection, quantity, gallery, description accordion,
   and the "Cast Spell" discount animation.
   ============================================================ */
(function () {
  var root = document.getElementById('pv-root');
  if (!root) return;

  /* ============================================================
     SOUND EFFECTS
     Paste your Shopify File URLs between the quotes below.
     (Shopify admin → Content → Files → upload the .wav → "Copy link")
     Leave blank to disable a sound.
     ============================================================ */
  var CLICK_SOUND_URL = 'https://cdn.shopify.com/s/files/1/0648/9509/0945/files/product_open.mp3?v=1791743250'; /* Add to Cart / Cast Spell / Activate Spell */
  var SIZE_SOUND_URL  = 'https://cdn.shopify.com/s/files/1/0648/9509/0945/files/size_button.mp3?v=1791743833'; /* size / option swatches */

  /* Web Audio engine (same as SHOP.DIR): buffers decoded up front for
     near-zero latency on mobile; HTMLAudio covers the first tap and
     no-WebAudio browsers. */
  var __sndCtx = null, __handles = {};
  function __mk(url, vol) {
    if (!url || __handles[url]) return;
    var h = { el: null, raw: null, buf: null, vol: vol || 0.5 };
    try { h.el = new Audio(url); h.el.preload = 'auto'; h.el.volume = h.vol; } catch (e) {}
    try {
      var x = new XMLHttpRequest(); x.open('GET', url); x.responseType = 'arraybuffer';
      x.onload = function () { if (x.status === 200) { h.raw = x.response; __dec(h); } };
      x.send();
    } catch (e) {}
    __handles[url] = h;
  }
  function __dec(h) {
    if (!__sndCtx || !h.raw || h.buf) return;
    try { __sndCtx.decodeAudioData(h.raw.slice(0), function (b) { h.buf = b; }, function () {}); } catch (e) {}
  }
  function __ensure() {
    if (!__sndCtx) {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      try { __sndCtx = new AC(); } catch (e) { return; }
      for (var k in __handles) __dec(__handles[k]);
    }
    if (__sndCtx.state === 'suspended') { try { __sndCtx.resume().catch(function () {}); } catch (e) {} }
  }
  document.addEventListener('touchend', __ensure, true);
  document.addEventListener('pointerdown', __ensure, true);
  __mk(CLICK_SOUND_URL, 0.5);
  __mk(SIZE_SOUND_URL, 0.45);

  function playSound(url) {
    var h = __handles[url];
    if (!h) {
      if (!url) return;
      try { var a = new Audio(url); a.volume = 0.5; a.play().catch(function () {}); } catch (e) {}
      return;
    }
    if (__sndCtx && h.buf && __sndCtx.state === 'running') {
      try {
        var s = __sndCtx.createBufferSource(); s.buffer = h.buf;
        var g = __sndCtx.createGain(); g.gain.value = h.vol;
        s.connect(g); g.connect(__sndCtx.destination); s.start(0);
        return;
      } catch (e) {}
    }
    if (h.el) { try { h.el.currentTime = 0; h.el.play().catch(function () {}); } catch (e) {} }
  }

  var SPELL_NAMES = [
    'VVYRM HOLLOW', 'THORNVEX SIGIL', 'CHLORA ABYSS', 'GLOOM TENDRIL',
    'NETH BLOOM', 'SPORE WRAITH', 'CREEP VEIN', 'ROT WHISPER',
    'MIRE ECHO', 'DUSK MYCEL'
  ];

  var select = document.getElementById('pv-variant-id');
  var priceEl = document.getElementById('pv-price');
  var priceWasEl = document.getElementById('pv-price-was');
  var mainImage = document.getElementById('pv-main-image');
  var addBtn = document.getElementById('pv-add-btn');

  var selectedOptions = [];
  // Seed selected options from active swatches
  document.querySelectorAll('.pv-option-values').forEach(function (group) {
    var idx = parseInt(group.getAttribute('data-option-index'), 10);
    var active = group.querySelector('.pv-swatch.is-active');
    if (active) selectedOptions[idx] = active.getAttribute('data-value');
  });

  function moneyFromCents(cents) {
    // Render using the shop's money_format pattern (e.g. "${{amount}}").
    var amount = (cents / 100).toFixed(2);
    var fmt = root.dataset.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  // ---------- Variant matching ----------
  function findMatchingOption() {
    if (!select) return null;
    var opts = select.options;
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      // Build the variant's option string from its label "A / B / C"
      var parts = o.textContent.split(' / ').map(function (s) { return s.trim(); });
      var match = true;
      for (var k = 0; k < selectedOptions.length; k++) {
        if (selectedOptions[k] != null && parts[k] !== selectedOptions[k]) { match = false; break; }
      }
      if (match) return o;
    }
    return null;
  }

  function applyVariant(option) {
    if (!option) return;
    select.value = option.value;
    var disabled = option.disabled;
    if (addBtn) {
      addBtn.disabled = disabled;
      var addLabel = addBtn.querySelector('.pv-pixel-label');
      if (addLabel) addLabel.textContent = disabled ? 'Sold Out' : (root.dataset.addLabel || addLabel.textContent);
    }
    // Price
    var cents = parseInt(option.getAttribute('data-price'), 10);
    if (!isNaN(cents) && priceEl && !discountApplied) {
      priceEl.dataset.base = cents;
      priceEl.textContent = moneyFromCents(cents);
    }
    // Image
    var img = option.getAttribute('data-image');
    if (img && mainImage) mainImage.src = img;
  }

  // Swatch clicks
  document.querySelectorAll('.pv-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      playSound(SIZE_SOUND_URL);
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      selectedOptions[idx] = btn.getAttribute('data-value');
      btn.parentNode.querySelectorAll('.pv-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      btn.classList.add('is-active');
      applyVariant(findMatchingOption());
    });
  });

  // ---------- Button click sound (Add to Cart / Cast Spell / Activate) ----------
  document.querySelectorAll('.pv-pixel').forEach(function (btn) {
    btn.addEventListener('pointerdown', function () {
      if (!btn.disabled) playSound(CLICK_SOUND_URL);
    });
  });

  // ---------- Quantity ----------
  var qtyInput = document.getElementById('pv-qty-input');
  document.querySelectorAll('.pv-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      v = btn.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(1, v - 1);
      qtyInput.value = v;
      playSound(SIZE_SOUND_URL);
    });
  });

  // ---------- Gallery thumbnails ----------
  document.querySelectorAll('.pv-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (full && mainImage) mainImage.src = full;
      document.querySelectorAll('.pv-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // ---------- Collapsible dropdown sections (Shipping, Care, …) ----------
  document.querySelectorAll('.pv-accordion-head').forEach(function (head) {
    var body = head.nextElementSibling;
    if (!body) return;
    head.addEventListener('click', function () {
      var open = body.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // ---------- Cast Spell ----------
  var discountApplied = false;
  var spellBtn = document.getElementById('pv-spell-btn');
  var modal = document.getElementById('pv-modal');
  var modalSpell = document.getElementById('pv-modal-spell');
  var modalActivate = document.getElementById('pv-modal-activate');
  var particleLayer = document.getElementById('pv-particles');
  var discountPct = parseInt(root.dataset.discountPct, 10) || 0;
  var discountCode = root.dataset.discountCode || '';

  function openModal() {
    if (!modal) return;
    modalSpell.textContent = SPELL_NAMES[Math.floor(Math.random() * SPELL_NAMES.length)];
    modal.hidden = false;
  }
  function closeModal() { if (modal) modal.hidden = true; }

  if (spellBtn) spellBtn.addEventListener('click', openModal);
  if (modal) {
    modal.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
  }

  function fireParticles() {
    if (!particleLayer || !spellBtn || !priceEl) return;
    var b = spellBtn.getBoundingClientRect();
    var p = priceEl.getBoundingClientRect();
    for (var i = 0; i < 12; i++) {
      (function (i) {
        var dot = document.createElement('div');
        dot.className = 'pv-particle';
        var sx = b.left + b.width / 2 + (Math.random() - 0.5) * 40;
        var sy = b.top + b.height / 2 + (Math.random() - 0.5) * 20;
        var ex = p.left + p.width / 2 + (Math.random() - 0.5) * 30;
        var ey = p.top + p.height / 2 + (Math.random() - 0.5) * 10;
        dot.style.left = sx + 'px';
        dot.style.top = sy + 'px';
        dot.style.transition = 'transform 0.6s ease-out, opacity 0.6s ease-out';
        dot.style.transitionDelay = (i * 0.03) + 's';
        particleLayer.appendChild(dot);
        requestAnimationFrame(function () {
          dot.style.transform = 'translate(' + (ex - sx) + 'px,' + (ey - sy) + 'px) scale(0.5)';
          dot.style.opacity = '0';
        });
        setTimeout(function () { dot.remove(); }, 800 + i * 30);
      })(i);
    }
  }

  function tickPrice() {
    var base = parseInt(priceEl.dataset.base, 10);
    var target = Math.round(base * (100 - discountPct) / 100);
    var steps = 30, step = 0;
    var diff = base - target;
    var interval = setInterval(function () {
      step++;
      var cur = Math.round(base - (diff * step / steps));
      priceEl.textContent = moneyFromCents(Math.max(target, cur));
      if (step >= steps) {
        clearInterval(interval);
        priceEl.textContent = moneyFromCents(target);
        priceEl.classList.add('is-discounted');
        if (priceWasEl) { priceWasEl.hidden = false; priceWasEl.textContent = moneyFromCents(base); }
        discountApplied = true;
      }
    }, 40);
  }

  if (modalActivate) {
    modalActivate.addEventListener('click', function () {
      if (discountApplied) return;
      closeModal();
      fireParticles();
      setTimeout(tickPrice, 600);
      modalActivate.disabled = true;
      var actLbl = modalActivate.querySelector('.pv-pixel-label');
      if (actLbl) actLbl.textContent = 'Spell Cast';
      if (spellBtn) {
        spellBtn.disabled = true;
        var lbl = spellBtn.querySelector('.pv-pixel-label');
        if (lbl) lbl.textContent = 'Spell Cast';
      }
    });
  }

  // ---------- Add to cart -> apply discount code at checkout ----------
  var form = document.getElementById('pv-form');
  if (form) {
    form.addEventListener('submit', function () {
      // If a spell was cast and a real discount code is configured,
      // stash it so checkout applies it.
      if (discountApplied && discountCode) {
        try {
          document.cookie = 'discount_code=' + encodeURIComponent(discountCode) + '; path=/';
        } catch (e) {}
        // Shopify honors /discount/CODE redirect to pre-apply at checkout.
        // We let the normal add proceed; the storefront cart will carry it.
      }
    });
  }

  // ---------- Community sale badge (store-wide spell-pool discount) ----------
  // Display-only: Shopify applies the real discount at checkout. We show the
  // reduced price + a green -X% badge whenever the pool is live, and re-apply
  // when the variant price changes.
  (function () {
    if (!priceEl) return;
    var badge = null;
    function apply(pct) {
      var base = parseInt(priceEl.dataset.base, 10);
      if (isNaN(base)) return;
      priceEl.textContent = moneyFromCents(Math.round(base * (100 - pct) / 100));
      priceEl.classList.add('is-discounted');
      if (priceWasEl) {
        priceWasEl.hidden = false;
        priceWasEl.textContent = moneyFromCents(base);
        priceWasEl.style.textDecoration = 'line-through';
        priceWasEl.style.opacity = '0.5';
        priceWasEl.style.marginLeft = '8px';
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.style.cssText = 'display:inline-flex;align-items:center;background:#3bec74;color:#000;font-weight:700;font-size:11px;letter-spacing:.06em;padding:3px 7px;border-radius:0;margin-left:10px;vertical-align:middle;font-family:inherit;';
        priceEl.parentNode.appendChild(badge);
      }
      badge.textContent = '-' + pct + '%';
    }
    fetch('https://ruinos-api.uuhdoubled.workers.dev/pool-status').then(function (r) { return r.json(); }).then(function (d) {
      if (!d || !d.active || !d.pct) return;
      apply(d.pct);
      if (window.MutationObserver) {
        new MutationObserver(function () { apply(d.pct); }).observe(priceEl, { attributes: true, attributeFilter: ['data-base'] });
      }
    }).catch(function () {});
  })();

  // (The old "header clearance" resize helper lived here. The stock header is
  // retired site-wide, and with it display:none its rect is 0 — on iOS the
  // URL-bar collapse fires resize mid-scroll, so the helper shoved a giant
  // margin onto .pv-details. Obsolete + harmful: removed.)
})();

// ---------- RELATED RECORDS (presentation only) ----------
// The stock Horizon recommendations section renders off-theme white cards.
// Rebuild it as a terminal panel using Shopify's own recommendations API.
// XHR with a string URL (the storefront fetch-patch gotcha). If anything
// fails, the section simply stays hidden (CSS hides it until .crt-rel-ready).
(function () {
  // This script evaluates INSIDE the product section, but the recommendations
  // section comes after it in the DOM — and ShopifyAnalytics.meta.product
  // populates from a later inline script. Poll for both.
  var tries = 0;
  (function waitBoot() {
    var sec = document.querySelector('.shopify-section[id*="product_recommendations"]');
    var pid = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product)
      ? ShopifyAnalytics.meta.product.id : null;
    if (!sec || !pid) { if (++tries < 25) setTimeout(waitBoot, 200); return; }
    build(sec, pid);
  })();
  function build(sec, pid) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/recommendations/products.json?product_id=' + pid + '&limit=4');
  xhr.onload = function () {
    try {
      var prods = (JSON.parse(xhr.responseText).products || []).slice(0, 4);
      if (!prods.length) return;
      function cents(p) { return (typeof p === 'number') ? p : Math.round(parseFloat(p) * 100); }
      function money(c) { return '$' + (c / 100).toFixed(2); }
      function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
      var html = '<div class="pvr"><p class="pvr-hd">// RELATED RECORDS</p><div class="dir-list">';
      prods.forEach(function (p, i) {
        var img = p.featured_image
          ? '<img class="th" src="' + esc(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" width="40" height="40" loading="lazy">'
          : '';
        html += '<a class="dir-row" href="' + esc(p.url) + '">' +
          '<span class="idx">[0' + (i + 1) + ']</span>' + img +
          '<span class="nm">' + esc(p.title.toUpperCase().replace(/ /g, '_')) + '.ITM</span>' +
          '<span class="pr">' + money(cents(p.price)) + '</span></a>';
      });
      html += '</div></div>';
      sec.innerHTML = html;
      sec.classList.add('crt-rel-ready');
    } catch (e) {}
  };
  xhr.send();
  }
})();
